<template>
  <div class="loading" v-if="loading">
  </div>
  <div v-else>
    <v-navigation-drawer floating app :mini-variant="drawer" permanent fixed clipped class="lateral-nav">
      <component :is="lateralUserElement" :club="club" v-if="$vuetify.breakpoint.xs" class="white--text"></component>

      <v-tooltip right open-delay="50" close-delay="50">
        <v-btn flat icon @click="expandLateralNav" class="ml-4" slot="activator">
          <v-icon color="#c4c9d0">menu</v-icon>
        </v-btn>
        <span>Colapsar/Expandir navegador lateral</span>
      </v-tooltip>

      <v-list dense>
        <LateralElement :item="dashboard" :drawer="drawer"></LateralElement>
      </v-list>
      <v-divider></v-divider>

      <template v-if="$store.getters.isSafRole">
        <v-list class="pt-0" dense>
          <LateralFichaElement :drawer="drawer"></LateralFichaElement>
        </v-list>
        <template v-if="$store.getters.hasFocusFicha">
          <LateralTitleElement :title="$store.state.club" v-if="!drawer">
            <v-list-tile-action>
              <v-tooltip bottom>
                <v-btn slot="activator" icon @click="closeClubInfo" flat>
                  <v-icon color="grey lighten-2">clear</v-icon>
                </v-btn>
                <span>Cerrar Información del club</span>
              </v-tooltip>
            </v-list-tile-action>
          </LateralTitleElement>
          <v-list class="pt-0" dense>
            <template>
              <template v-if="!drawer">
                <SearchCriterion v-show="$store.state.fichaAreas.length"></SearchCriterion>
                <LateralFichaArea v-for="area in $store.state.fichaAreas" :key="area.pk" :area="area"></LateralFichaArea>
              </template>
              <template v-else>
                <DividerLineElement v-show="drawer"></DividerLineElement>
                <LateralFichaAreaMini v-for="area in $store.state.fichaAreas" :key="area.pk" :area="area"></LateralFichaAreaMini>
              </template>
            </template>
          </v-list>
        </template>
      </template>

      <v-list class="pt-0" dense v-if="$store.getters.isClubRole">
        <template v-if="!drawer">
          <SearchCriterion v-show="areas.length"></SearchCriterion>
          <template v-for="area in areas">
            <LateralFichaArea :key="area.pk" :area="area"></LateralFichaArea>
            <v-divider :key="area.pk + 'divider'" light v-if="areas.indexOf(area) !== areas.length - 1"></v-divider>
          </template>
        </template>
        <template v-if="drawer">
          <DividerLineElement v-show="areas.length"></DividerLineElement>
          <LateralFichaAreaMini v-for="area in areas" :key="area.pk" :area="area" :drawer="drawer"></LateralFichaAreaMini>
        </template>
      </v-list>

      <LateralTitleElement v-if="!drawer" title="Servicios">
        <v-list-tile-action v-if="$store.getters.isSafRole">
          <LateralNavConfiguration></LateralNavConfiguration>
        </v-list-tile-action>
      </LateralTitleElement>

      <v-list class="pt-0" dense>
        <DividerLineElement v-show="drawer"></DividerLineElement>
        <template v-for="item in services">
          <template v-if="item.visibility">
            <LateralElement :key="item.title" :item="item" :drawer="drawer">
              <v-chip v-if="item.ifChips" color="warning darken-1" small text-color="warning darken-1" outline>{{ item.chips }}</v-chip>
            </LateralElement>
            <v-divider light :key="item.title + 'divider'" v-if="services.indexOf(item) !== services.length - 1"></v-divider>
          </template>
        </template>
      </v-list>

      <template v-if="canViewEconomics">
        <LateralTitleElement v-if="!drawer" title="Control Económico-Financiero"></LateralTitleElement>
        <v-list class="pt-0" dense>
          <DividerLineElement v-show="drawer"></DividerLineElement>
          <template v-for="item in economics">
            <template v-if="item.visibility">
              <LateralElement :key="item.title" :item="item" :drawer="drawer"></LateralElement>
              <v-divider light :key="item.title + 'divider'" v-if="economics.indexOf(item) !== economics.length - 1"></v-divider>
            </template>
          </template>
        </v-list>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import LateralElement from './LateralElement'
import LateralFichaElement from './LateralFichaElement'
import LateralFichaArea from './LateralFichaArea'
import LateralFichaAreaMini from './LateralFichaAreaMini'
import LateralTitleElement from './LateralTitleElement'
import LateralUserElementSaf from './LateralUserElementSaf'
import LateralUserElementClub from './LateralUserElementClub'
import LateralNavConfiguration from './LateralNavConfiguration'
import DividerLineElement from './DividerLineElement'
import * as Sentry from '@sentry/browser'
import SearchCriterion from './SearchCriterion'

export default {
  components: {
    LateralElement,
    LateralFichaElement,
    LateralFichaArea,
    LateralFichaAreaMini,
    LateralTitleElement,
    LateralNavConfiguration,
    LateralUserElementSaf,
    LateralUserElementClub,
    DividerLineElement,
    SearchCriterion
  },

  data () {
    return {
      loading: false,
      areas: [],
      club: {},
      permisos: {},
      dashboard: {
        title: 'Dashboard',
        icon: 'dashboard',
        action: 'dashboard'
      },
      pantallas: {}
    }
  },

  computed: {
    drawer: {
      get () {
        return this.$store.state.miniLateralNav
      },
      set (value) {
        this.$store.commit('setMiniLateralNav', value)
      }
    },
    lateralUserElement () {
      return 'LateralUserElement' + this.$store.getters.role
    },
    services () {
      return [
        {
          title: 'Presentaciones',
          icon: 'mdi-file-document-outline',
          action: 'presentaciones',
          visibility: this.permisos.canViewPresentaciones && this.pantallas.screenActivePresentaciones
        },
        {
          title: 'Presentaciones LPF',
          icon: 'mdi-file-document-edit',
          action: 'presentacionesCargaLpf',
          visibility: this.permisos.canViewPresentacionesCargaLpf && this.pantallas.screenActivePresentacionesLpf
        },
        {
          title: 'Actualizaciones',
          icon: 'edit',
          action: 'actualizaciones',
          chips: 'En progreso',
          visibility: this.permisos.canViewActualizaciones,
          ifChips: this.$store.getters.hasDraftInProgress && !this.drawer && this.pantallas.screenActiveActualizaciones
        },
        {
          title: 'Notificaciones',
          icon: 'notifications_none',
          action: 'notificaciones',
          visibility: true && this.pantallas.screenActiveNotificaciones
        },
        {
          title: 'Comunicaciones',
          icon: 'mdi-bullhorn-outline',
          action: 'boletines',
          visibility: this.permisos.canViewBoletines && this.pantallas.screenActiveComunicaciones
        },
        {
          title: 'Eventos',
          icon: 'event',
          action: 'eventos',
          visibility: this.permisos.canViewEventos && this.pantallas.screenActiveEventos
        },
        {
          title: 'Consultas',
          icon: 'mdi-comment-text-outline',
          action: 'consultas',
          visibility: this.permisos.canViewConsultas && this.pantallas.screenActiveConsultas
        },
        {
          title: 'Expedientes',
          icon: 'inbox',
          action: 'expedientes',
          visibility: this.permisos.canViewExpedientes && this.pantallas.screenActiveExpedientes
        },
        {
          title: 'Reportes',
          icon: 'fa-clipboard-list',
          action: 'reporte-people',
          visibility: this.permisos.canViewReportes && this.$store.getters.isSafRole && this.pantallas.screenActiveReportes
        },
        {
          title: 'Informes Generales',
          icon: 'mdi-library-books',
          action: 'informes-auditorias',
          visibility: this.permisos.canViewInformesAuditorias && this.pantallas.screenActiveInformesGenerales
        },
        {
          title: 'Informes Auditoria Club',
          icon: 'mdi-book',
          action: 'informes-auditorias-club',
          visibility: this.pantallas.screenActiveInformesAuditoriasCargaClub && this.permisos.canViewInformeAuditoriasCargaClub
        },
        {
          title: 'Reportes Auditoria Club',
          icon: 'mdi-chart-pie',
          action: 'reportes-info-club',
          visibility: this.pantallas.screenActiveReportesInformesAuditoriasCargaClub && this.permisos.canViewReportesInformeAuditoriasCargaClub
        },
        {
          title: 'Informes de Partidos',
          icon: 'fa-solid fa-futbol',
          action: 'selector-todos',
          visibility: this.permisos.canViewInformesAuditorias && this.pantallas.screenActiveInformesPartidos
        },
        {
          title: 'Reportes Partidos',
          icon: 'mdi-chart-pie',
          action: 'reporte-partido-info',
          visibility: this.permisos.canViewInformesAuditorias && this.$store.getters.isSafRole && this.pantallas.screenActiveReportesPartidos
        },
        {
          title: 'Fichas de Partidos',
          icon: 'mdi-soccer-field',
          action: 'fichasDePartidos',
          visibility: this.permisos.canViewFichasPartido && this.pantallas.screenActiveFichasPartidos
        }
      ]
    },
    economics () {
      let jugadores = {
        title: 'Contratos Jugadores',
        icon: 'gavel',
        action: 'jugadores',
        visibility: this.canViewContratos && this.pantallas.screenActiveContratosJugadores
      }
      let cuerpoTecnico = {
        title: 'Contratos Cuerpo Técnico',
        icon: 'gavel',
        action: 'cuerpoTecnico',
        visibility: this.permisos.canViewCuerpoTecnico && this.pantallas.screenActiveContratosCuerpoTecnico
      }
      let liquidaciones = {
        title: 'Liquidaciones',
        icon: 'live_tv',
        action: 'liquidacionestv',
        visibility: this.canViewLiquidacionestv && this.pantallas.screenActiveLiquidaciones
      }
      let liquidacionesJugadores = {
        title: 'Reporte Mensual de Salarios',
        icon: 'sports_soccer',
        action: 'liquidacionesJugadores',
        visibility: this.canViewLiquidacionesjugadores && this.pantallas.screenActiveReporteMensualSalarios
      }
      let presupuestos = {
        title: 'Presupuestos',
        icon: 'attach_money',
        action: 'presupuesto',
        visibility: this.permisos.canViewPresupuestos && this.pantallas.screenActivePresupuestos
      }
      let informesDePagosJugadores = {
        title: 'Informes de Pagos Jugadores',
        icon: 'request_quote',
        action: 'informesJugadores',
        visibility: this.permisos.canViewInformes && this.pantallas.screenActiveInformesPagosJugadores
      }
      let informesDePagosCuerpoTecnico = {
        title: 'Informes de Pagos Cuerpo Técnico',
        icon: 'request_quote',
        action: 'informesCuerpoTecnico',
        visibility: this.permisos.canViewInformes && this.permisos.canViewCuerpoTecnico && this.pantallas.screenActiveInformesPagosCuerpoTecnico
      }
      if (this.permisos.canViewCuerpoTecnico) {
        jugadores.initials = 'J'
        cuerpoTecnico.initials = 'CT'
        informesDePagosJugadores.initials = 'J'
        informesDePagosCuerpoTecnico.initials = 'CT'
      }
      let deudasEntreClubes = {
        title: 'Deudas entre Clubes',
        icon: 'transfer_within_a_station',
        action: 'deudasEntreClubes',
        visibility: this.permisos.canViewDeudas && this.pantallas.screenActiveDeudasEntreClubes
      }
      let TransferenciasJugadores = {
        title: 'Transferencias de jugadores',
        icon: 'fa-briefcase',
        action: 'selector-transferencias',
        visibility: (this.permisos.canViewTransferenciasJugadores || this.permisos.canViewJugadoresCedidos) && this.pantallas.screenActiveTransferenciasJugadores
      }
      let wizardJugadoresDuplicados = {
        title: 'Jugadores duplicados',
        icon: 'fa-address-card',
        action: 'wizard-jug-dup',
        visibility: this.permisos.canViewJugadoresDuplicados && this.pantallas.screenActiveJugadoresDuplicados && this.$store.getters.isSafRole
      }
      let wizardJugadoresDuplicadosTecnico = {
        title: 'Cuerpo Técnico duplicado',
        icon: 'fa-address-card',
        action: 'wizard-tec-dup',
        visibility: this.permisos.canViewJugadoresDuplicados && this.pantallas.screenActiveCuerpoTecnicoDuplicado && this.$store.getters.isSafRole
      }
      if (this.permisos.canViewCuerpoTecnico) {
        wizardJugadoresDuplicadosTecnico.initials = 'CT'
      }
      return [
        liquidaciones,
        liquidacionesJugadores,
        presupuestos,
        jugadores,
        cuerpoTecnico,
        informesDePagosJugadores,
        informesDePagosCuerpoTecnico,
        deudasEntreClubes,
        TransferenciasJugadores,
        wizardJugadoresDuplicados,
        wizardJugadoresDuplicadosTecnico
      ]
    },
    canViewEconomics () {
      return this.canViewLiquidacionestv || this.canViewLiquidacionesjugadores ||
             this.permisos.canViewPresupuestos || this.canViewContratos || this.permisos.canViewTransferenciasJugadores || this.permisos.canViewJugadoresCedidos
    },
    canViewContratos () {
      if (!this.permisos.canViewContratos) {
        return false
      }

      if (this.$store.getters.isSafRole) {
        return true
      }

      return !this.areas.some(area => area.showContracts)
    },
    canViewLiquidacionestv () {
      if (!this.permisos.canViewLiquidacionestv) {
        return false
      }

      if (this.$store.getters.isSafRole) {
        return true
      }

      return !this.areas.some(area => area.showSettlements)
    },
    canViewLiquidacionesjugadores () {
      if (!this.permisos.canViewLiquidacionesjugadores) {
        return false
      }

      if (this.$store.getters.isSafRole) {
        return true
      }

      return !this.areas.some(area => area.showSettlements)
    }
  },

  methods: {
    fetchData () {
      this.axios
        .get('/frontend/menu')
        .then((response) => {
          this.areas = response.data.areas
          this.club = response.data.club
          this.permisos = response.data.permisos
          this.pantallas = response.data.pantallas
          this.$store.commit('setPermissions', response.data.permisos)
          this.$store.commit('setPantallas', response.data.pantallas)
          if (response.data.club.nombre) this.$store.commit('setClub', response.data.club.nombre)
          if (response.data.club.logo) this.$store.commit('setIcon', response.data.club.logo)
          this.$store.commit('fetchDraft')
          this.configureSentryScopeIfRequired(response)
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    configureSentryScopeIfRequired (response) {
      if (process.env.NODE_ENV !== 'development') {
        Sentry.configureScope((scope) => {
          scope.setUser({
            username: response.data.username
          })
          scope.setExtra('rol', response.data.rol)
          scope.setExtra('permisos', response.data.permisos)
          if (response.data.club) {
            scope.setExtra('club', response.data.club)
          }
        })
      }
    },
    expandLateralNav () {
      this.$store.commit('changeLateralNav')
    },
    closeClubInfo () {
      this.$store.commit('setFichaAreas', [])
    }
  },

  mounted () {
    this.loading = true
    this.fetchData()
  }
}
</script>

<style scoped>
.lateral-nav {
  background-color: #42669f;
}
/* width */
::-webkit-scrollbar {
  width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #42669f;
}

::-webkit-scrollbar-track-piece {
  width: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(62, 77, 99, 0.8);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #3d3d3d;
}
</style>
